<div>
  <form [formGroup]="subscriptionForm">
    <div formArrayName="subscriptions">
      <nz-table
        #sortTable
        [nzData]="
          subscriptions.controls.length > 0 ? subscriptions.controls : []
        "
        [nzLoading]="loading"
        [nzSize]="'middle'"
        [nzShowPagination]="true"
        [nzTotal]="totalRow"
        [(nzPageSize)]="pageSize"
        [(nzPageIndex)]="pageIndex"
        [nzNoResult]="customNoResult"
        (nzQueryParams)="onQueryParamsChange($event)">
        <thead>
          <tr>
            <th scope="col" nzWidth="8%" [title]="listOfColumn[0].title">
              {{ listOfColumn[0].title }}
            </th>
            <th scope="col" nzWidth="8%" [title]="listOfColumn[1].title">
              {{ listOfColumn[1].title }}
            </th>
            <th
              scope="col"
              [nzSortFn]="true"
              [title]="listOfColumn[2].title"
              [nzColumnKey]="listOfColumn[2].key">
              {{ listOfColumn[2].title }}
            </th>
            <th
              scope="col"
              [nzSortFn]="true"
              [title]="listOfColumn[3].title"
              [nzColumnKey]="listOfColumn[3].key">
              {{ listOfColumn[3].title }}
            </th>
            <th scope="col">
              {{ listOfColumn[4].title }}
            </th>
            <th
              scope="col"
              *ngIf="(orgParams && orgParams.isParentOrganization) || false">
              {{ listOfColumn[5].title }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of subscriptions.controls; let i = index"
            [formGroupName]="i">
            <td>
              <nz-switch
                formControlName="isCMS"
                [nzDisabled]="disableControl(i)" />
            </td>

            <td>
              <nz-switch
                formControlName="isLearning"
                [nzDisabled]="disableControl(i)" />
            </td>

            <td>
              <nz-date-picker
                formControlName="startDate"
                nzFormat="MM/dd/yyyy"
                [nzDisabledDate]="disableDates"
                nzAllowClear="false"
                [nzDisabled]="disableControl(i)"></nz-date-picker>
            </td>

            <!-- Is CMS -->
            <td>
              <nz-date-picker
                formControlName="endDate"
                nzFormat="MM/dd/yyyy"
                [nzDisabledDate]="disableEndBeforeStart(i)"
                nzAllowClear="false"
                [nzDisabled]="disableControl(i)"></nz-date-picker>
            </td>

            <!-- Remarks -->
            <td>
              <textarea
                formControlName="remarks"
                [id]="'remarks' + i"
                rows="2"
                nz-input
                [nzBorderless]="false"
                placeholder="Enter your text"
                [disabled]="disableControl(i)"></textarea>
              <div class="mt-3 remaining-text" *ngIf="editingIndex === i">
                {{
                  subscriptions.value[i].remarks
                    ? subscriptions.value[i].remarks.length
                    : 0
                }}
                of 500 characters used
              </div>
              <div
                class="ant-form-item-explain-error mt-3"
                *ngIf="item.get('remarks')?.hasError('maxlength')">
                Remarks cannot exceed 500 characters!
              </div>
            </td>

            <!-- Actions -->
            <td *ngIf="(orgParams && orgParams.isParentOrganization) || false">
              <div class="action-btn-wrapper" *ngIf="editingIndex === i">
                <button
                  type="button"
                  type="button"
                  nz-button
                  [nzType]="'default'"
                  class="btn"
                  (click)="onCancel(i)">
                  Cancel
                </button>
                <button
                  type="button"
                  type="button"
                  nz-button
                  [nzType]="'primary'"
                  class="btn"
                  [nzLoading]="isUpdating[i] && loading"
                  [disabled]="loading || subscriptionForm.invalid"
                  (click)="submitScription(i)">
                  Save
                </button>
              </div>
              <div class="action-btn-wrapper" *ngIf="editingIndex !== i">
                <div class="action-dropdown">
                  <button
                    nz-button
                    nz-dropdown
                    [nzDropdownMenu]="menu"
                    nzTrigger="click"
                    [nzPlacement]="'bottomLeft'"
                    nzType="text"
                    type="button"
                    class="action-btn">
                    <svg-icon
                      [title]="'More options'"
                      src="/assets/icon/icon-more.svg"
                      class="icon s-20"
                      aria-label="More"></svg-icon>
                  </button>
                  <nz-dropdown-menu #menu="nzDropdownMenu">
                    <ul nz-menu>
                      <li
                        nz-menu-item
                        nzClickHide="false"
                        class="action-list-item">
                        <button
                          nz-button
                          [nzType]="'text'"
                          tabindex="0"
                          class="text s-14 list-item"
                          (click)="editSub(i)"
                          (keydown.enter)="editSub(i)">
                          <svg-icon
                            src="/assets/icon/icon-edit.svg"
                            class="icon s-20"
                            aria-label="Edit"></svg-icon>
                          <span class="text s-14">Edit</span>
                        </button>
                      </li>
                      <li
                        nz-menu-item
                        nzClickHide="false"
                        class="action-list-item">
                        <button
                          nz-button
                          [nzType]="'text'"
                          (click)="showDeleteModal(i)"
                          (keydown.enter)="showDeleteModal(i)"
                          tabindex="0"
                          class="text s-14 list-item">
                          <svg-icon
                            src="/assets/icon/icon-trash.svg"
                            class="icon s-16 fw-500"
                            aria-label="Trash"></svg-icon>
                          <span class="text s-14">Delete</span>
                        </button>
                      </li>
                    </ul>
                  </nz-dropdown-menu>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>
  </form>
</div>

<app-confirm-dialog
  [isVisible]="isVisible"
  [title]="'Delete Item'"
  [message]="
    'Are you sure you want to delete this subscription? This action cannot be undone.'
  "
  [iconSrc]="'/assets/icon/icon-trash-red.svg'"
  [iconColor]="'red'"
  [cancelText]="'Cancel'"
  [loading]="isDeleting"
  [confirmText]="'Delete'"
  (confirmed)="handleOkMiddle()"
  (cancelled)="handleCancelMiddle()"
  (closed)="handleCancelMiddle()">
</app-confirm-dialog>

<ng-template #customNoResult>
  <div class="no-data-wrapper" *ngIf="totalRow === 0">
    <div class="no-data-text">No Data</div>
  </div>
</ng-template>
